import { CSSObjectWithLabel, StylesConfig } from 'react-select';
import { Option } from '../models/table-models';
import {
    BatteryPassport,
    OilPassport,
    PassportType,
    ShortDevicePassport,
    ShortOilPassport
} from '../models/warehouse-models';

const dot = (color = 'transparent') => ({
    alignItems: 'center',
    display: 'flex',
    ':before': {
        backgroundColor: color,
        borderRadius: 10,
        content: '" "',
        display: 'block',
        marginRight: 8,
        height: 10,
        width: 10,
    },
});
export const colorSelectStyles: StylesConfig<Option, false> = {
    control: (styles) => ({ ...styles, backgroundColor: 'white' }),
    option: (styles, { data, isDisabled, isSelected }) => {
        const color = data.value;
        return {
            ...styles,
            backgroundColor: isSelected ? color : '#fff',
            color: isSelected ? '#fff' : color,
            cursor: isDisabled ? 'not-allowed' : 'default',
        };
    },
    input: (styles) => ({ ...styles, ...dot() }),
    placeholder: (styles) => ({ ...styles, ...dot('#ccc') }),
    singleValue: (styles, { data }) => ({ ...styles, ...dot(data.value) }),
};

const newRequestSelectStyles = {
    container: (base: CSSObjectWithLabel) => ({
        ...base,
        fontSize: '14px',
        width: '75%',
    }),
    control: (base: CSSObjectWithLabel) => ({
        ...base,
        height: '28px',
        minHeight: '28px',
    }),
    dropdownIndicator: (base: CSSObjectWithLabel) => ({
        ...base,
        padding: '0px',
    }),
    clearIndicator: (base: CSSObjectWithLabel) => ({
        ...base,
        padding: '0px',
    }),
    valueContainer: (base: CSSObjectWithLabel) => ({
        ...base,
        padding: '0px',
    }),
    input: (base: CSSObjectWithLabel) => ({
        ...base,
        fontSize: '14px',
    }),
};

export const devicePassportsSelectStyles: StylesConfig<ShortDevicePassport, false> = newRequestSelectStyles;
export const oilPassportSelectStyles: StylesConfig<OilPassport, false> = newRequestSelectStyles;
export const BatteryPassportSelectStyles: StylesConfig<BatteryPassport, false> = newRequestSelectStyles;
export const shortOilPassportsSelectStyles: StylesConfig<ShortOilPassport, false> = newRequestSelectStyles;

export const typeSelectStyles: StylesConfig<PassportType, false> = {
    input: (styles) => ({ ...styles, minWidth: '50px' }),
};

export const optionSelectStyles = {
    control: (base: CSSObjectWithLabel) => ({
        ...base,
        minHeight: '32px',
        height: '32px',
        fontSize: '14px',
    }),
    valueContainer: (base: CSSObjectWithLabel) => ({
        ...base,
        padding: '0 8px',
        fontSize: '14px',
    }),
    input: (styles: CSSObjectWithLabel) => ({ ...styles, minWidth: '100px', margin: 0, padding: 0, fontSize: '14px' }),
    indicatorsContainer: (base: CSSObjectWithLabel) => ({
        ...base,
        height: '32px',
    }),
    dropdownIndicator: (base: CSSObjectWithLabel) => ({
        ...base,
        padding: '4px',
    }),
    clearIndicator: (base: CSSObjectWithLabel) => ({
        ...base,
        padding: '4px',
    }),
    option: (base: CSSObjectWithLabel) => ({
        ...base,
        fontSize: '14px',
    }),
};

export const distributorSelectStyles = {
    input: (styles: CSSObjectWithLabel) => ({ ...styles, width: '100%' }),
};

export const newRequestContainerSelectStyles = (styles: any) =>
    ({
        ...styles,
        fontSize: '14px',
        padding: '0px',
    } as CSSObjectWithLabel);

export const checkered = (index: number): string => (index % 2 === 1 ? 'bg-dark-gray' : '');
